export const GRAPHQL_PATH = '/soa/graphql/';
export const QUERY_STRING_HEADER = 'x-dibs-query-params';

export const PASS_THROUGH_PARAM_PREFIXES = [
    'enabler-',
    'featureFlag-',
    'userAbTest-',
    'abtests',
] as const;
